export const Marks = ( {data, x, y, color, innerHeight, onHover, hovered}) => (
  data.map((d, i) => {
    // if it doesn't get called, the coloring is absolutely weird
    // previously it was called due to console.log, and after removing it,
    // the bug started to appear!
    const barColor = color(d.fatty_acid);  
    return (
        <rect 
          className={
          hovered === d.fatty_acid ? "active" : "inactive"
        }
          key={i}
          x={x(d.fatty_acid)}
          y={y(d.probability)} 
          width={x.bandwidth()}
          height={innerHeight - y(d.probability)}
          fill={barColor}
          onMouseEnter={e => onHover(d.fatty_acid)}
          onMouseLeave={e => onHover(null)}
        />
      )
  }
  )
);
